<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-4.mt-3.pb-3 {{ $tf("drawer.contracts.title") }}
  v-layout(:class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card(width="100%")
      v-card-text
        v-list.overflow-x-hidden
          v-list-tile.px-2(avatar ripple @click="download('/static/link/contract_kaz.doc')")
            v-list-tile-content
              v-list-tile-title «Казцинк» ЖШС-ның ҰЖЫМДЫҚ ШАРТЫ
          v-list-tile.px-2(avatar ripple @click="download('/static/link/contract_ru.doc')")
            v-list-tile-content
              v-list-tile-title КОЛЛЕКТИВНЫЙ ДОГОВОР ТОО «Казцинк»
    
</template>
  
<script>

export default {
  name: 'Contracts',

  methods: {
    download(url) {
      if (window.cordova !== undefined) {
        window.cordova.InAppBrowser.open(url, '_system', 'hidenavigationbuttons=yes,hideurlbar=yes,zoom=no,toolbarcolor=#272727,closebuttoncolor=#ffffff')
      } else {
        window.open(url, '_system')
      }
    },
  },
}

</script>

<style lang="stylus"></style>
  


// WEBPACK FOOTER //
// src/components/contracts/Contracts.vue